/**
 * Custom hook for Mutu Ancak data management
 */

import { useState, useEffect, useCallback } from 'react';
import { MutuAncakData, MutuAncakFilters, PenaltyRate } from '../types';
import MutuAncakApiService from '../services/mutuAncakApiService';

export const useMutuAncak = () => {
  const [data, setData] = useState<MutuAncakData[]>([]);
  const [penaltyRates, setPenaltyRates] = useState<PenaltyRate[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async (filters: MutuAncakFilters) => {
    if (!filters.estate_id || !filters.division_id || !filters.inspection_date) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const result = await MutuAncakApiService.getSummary(filters);
      // Depending on structure if result is wrapped in something or directly contains penalty_rates and data
      setData(result.data || []);
      setPenaltyRates(result.penalty_rates || []);
    } catch (err: any) {
      setError(err.message || 'Failed to fetch data');
      setData([]);
      setPenaltyRates([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    data,
    penaltyRates,
    loading,
    error,
    fetchData,
  };
};

export default useMutuAncak;
